import { render, staticRenderFns } from "./MidwifeMailPage.vue?vue&type=template&id=81f9880e"
import script from "./MidwifeMailPage.vue?vue&type=script&lang=js"
export * from "./MidwifeMailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports